module.exports = __webpack_public_path__ + "static/media/speech_00.240931cc.svg";